var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoyaltyManagement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M269.36,84.1V415.9c0,17.45,27.12,17.48,27.12,0V84.1c0-17.45-27.12-17.48-27.12,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.5,178.26c-11.94-24.73-42.31-25.82-66.14-26.9q-52.31-2.37-104.69-2.64Q124.94,148.15,20.4,156c-15.3,1.13-18.34,21.52-3.6,26.63,150.78,52.32,315.84,67,455.67,148.41l6.84-25.27a1568.9,1568.9,0,0,0-338.39,67.36c-16.57,5.26-9.49,31.45,7.21,26.15a1536.1,1536.1,0,0,1,331.18-66.39c12.8-1.11,19.21-18.06,6.85-25.26-142.07-82.76-309-98-462.15-151.15L20.4,183.08Q116,176,211.85,175.8q46.79-.08,93.57,1.53c15.32.52,30.83.61,46.1,2.09,9.9,1,20.89,2.84,25.56,12.52,7.59,15.72,31,2,23.42-13.68Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoyaltyManagement);
export default __webpack_public_path__ + "static/media/Royalty Management.28564d8a3df358c043921bc3891a7426.svg";
export { ForwardRef as ReactComponent };